import { withInstall } from '@hd-front-end/utils'
import Select from './src/select.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElSelectV2: SFCWithInstall<typeof Select> = withInstall(Select)
export default ElSelectV2

export * from './src/token'
